module.exports = __webpack_public_path__ + "static/media/li.4182b42d.svg";